import {
    Actions
} from 'libs/enums';

export class SecurityAction {
  /** Defines a single right, like READ, CREATE, UPDATE etc... */
    constructor(resourceid, action) {
        this.ID = resourceid;
        this.Action = action;
    }
}


export class SecurityGroupAction {
  /** Applies CRUD rights to a resource */
  constructor(resourceid) {
      this.Create = new SecurityAction(resourceid, Actions.Create);
      this.Update = new SecurityAction(resourceid, Actions.Update);
      this.Read = new SecurityAction(resourceid, Actions.Read);
      this.Delete = new SecurityAction(resourceid, Actions.Delete);
      this.CreateOrUpdate = new SecurityAction(resourceid, Actions.CreateOrUpdate);
  }
}